var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M12 3c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9zm0 2.25c-3.728 0-6.75 3.022-6.75 6.75s3.022 6.75 6.75 6.75 6.75-3.022 6.75-6.75S15.728 5.25 12 5.25z","transform":"translate(-28 -114) translate(0 109) translate(28 5)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }